import ServiceHero from '@/components/sections/ServiceHero'

export default function AutomationHero() {
  return (
    <ServiceHero
      serviceName="Automation"
      titleLines={['AI Workflows', 'That Scale']}
      description="Workflows and copilots that multiply your team's output. We automate the mundane so your team can focus on the high-leverage work that actually matters."
    />
  )
}
